import React from 'react';
import './Footer.css';

const Footer = () => (
  <footer className="footer">
    <div className="footer-grid">
      <div className="footer-brand">
        <h3>Classic Fence &amp; Deck</h3>
        <p>Best Price Guaranteed</p>
        <p>Serving Hamilton and surrounding areas</p>
      </div>
      <div className="footer-contact">
        <h4>Contact Aaron</h4>
        <a href="tel:+19059796010">📞 905-979-6010</a>
        <a href="mailto:aaronchiarot7@gmail.com">✉ aaronchiarot7@gmail.com</a>
      </div>
      <div className="footer-services">
        <h4>Services</h4>
        <ul>
          <li>Custom Wood Fencing</li>
          <li>Wrought Iron</li>
          <li>Chain Link</li>
          <li>Decks &amp; Patios</li>
          <li>Repairs</li>
        </ul>
      </div>
    </div>
    <div className="footer-bottom">
      <p>
        Website created by{' '}
        <a href="https://www.dudigital.ca" target="_blank" rel="noopener noreferrer">
          DuDigital.ca
        </a>
      </p>
    </div>
  </footer>
);

export default Footer;
